var checkAuth = function(policy, scope) {
  return policy && !_.includes(policy, (scope.user.is_admin || 
                                        scope.user.role ||
                                        ((scope.user.distributors || [])[0] || {}).role ||
                                        (scope.user.manufacturer || {}).role));
                                        
};

var directive = function($rootScope) {
  return {
    scope: {},
    restrict: 'A',
    link: function(scope, element, attrs) {
      var policy = ($rootScope.policies || {})[attrs.tizauth];
      if (!policy || checkAuth(policy, $rootScope)) {
        element.addClass('tizauth-hidden');
      }
      
      if (!$rootScope.policies) {
        var unwatch = scope.$watchCollection(function() { return (_.get($rootScope, 'policies') || {})[attrs.tizauth]; }, function (value) {
          if (!$rootScope.policies) { return; }
          unwatch();
          if (!value) { return; }
          if (checkAuth(value, $rootScope)) {
            element.addClass('tizauth-hidden');
          } else {
            element.removeClass('tizauth-hidden');
          }
        });
      }
    }
  };
};
directive.$inject = ['$rootScope'];

tiz.directive('tizauth', directive);

var directive2 = function($rootScope) {
  return {
    scope: {},
    restrict: 'A',
    link: function(scope, element, attrs) {
      if (!$rootScope.policies) { return; }
      var policy = $rootScope.policies[attrs.tizunauth];
      if (checkAuth(policy, $rootScope)) {
        element.show();
      } else {
        element.hide();
      }
    }
  };
};
directive2.$inject = ['$rootScope'];

tiz.directive('tizunauth', directive2);
